import {
  DEFAULT_INTERACTION_LABELS,
  type LabelGroups,
} from './default-interaction-labels';

/**
 * Holds the gateway's `/config/labels` data in memory and looks up the
 * suggested English label for a constant identifier. Seeded from the bundled
 * defaults so lookups work before (or without) a live fetch; `setLabels`
 * replaces the cache wholesale once `/config/labels` has been fetched.
 */
export class InteractionLabelsService {
  private labels: LabelGroups;

  constructor(seed: LabelGroups = DEFAULT_INTERACTION_LABELS) {
    // Shallow-clone so the shared default constant is never mutated.
    this.labels = { ...seed };
  }

  /** Suggested gateway label for `id` in `group`, or undefined if absent. */
  getGatewayLabel(group: string, id: string): string | undefined {
    return this.labels[group]?.[id];
  }

  /** Replace the entire label set (e.g. after fetching `/config/labels`). */
  setLabels(labels: LabelGroups): void {
    this.labels = labels;
  }
}

/** Process-wide labels cache shared by the message builder and UI components. */
export const interactionLabels = new InteractionLabelsService();
